import ServiceTemplate from '@/components/ServiceTemplate';

export default function PatentLegal() {
  const data = {
    title: 'Patent Legal Services',
    subtitle: 'Comprehensive patent legal services including enforcement and licensing.',
    overviewTitle: 'Protecting Your Patent Rights',
    overviewImage: 'https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13',
    description: [
      'Patent legal services go beyond application filing to include enforcement, licensing, litigation, and strategic portfolio management. These services protect and maximize the value of your patent rights.',
      'Our experienced patent attorneys provide comprehensive legal support including infringement analysis, cease and desist actions, licensing negotiations, and litigation representation when necessary.',
      'We help you protect your innovations, generate revenue through licensing, and take decisive action against patent infringement to maintain your competitive advantage.'
    ],
    benefits: [
      { title: 'Enforcement', description: 'Protect patents against infringement.' },
      { title: 'Licensing Revenue', description: 'Generate income through patent licensing.' },
      { title: 'Litigation Support', description: 'Experienced patent litigation representation.' },
      { title: 'Strategic Advice', description: 'Portfolio management and strategy guidance.' },
      { title: 'Infringement Analysis', description: 'Professional infringement assessments.' },
      { title: 'Negotiation', description: 'Skilled licensing and settlement negotiation.' }
    ],
    process: [
      { title: 'Case Evaluation & Evidence', description: 'Comprehensive analysis of infringement and collection of supporting evidence.' },
      { title: 'Strategic Action & Negotiation', description: 'Enforcement action implementation and settlement negotiations with infringers.' },
      { title: 'Resolution & Protection', description: 'Securing favorable outcome and implementing ongoing protection measures.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Patent evaluation',
        price: '$499',
        period: 'One-time fee',
        features: [
          'Patentability assessment',
          'Prior art search',
          'Patent strategy consultation',
          'Feasibility analysis',
          'Written opinion',
          'Filing recommendations'
        ]
      },
      {
        name: 'Utility Patent',
        description: 'Full patent application',
        price: '$5,999',
        period: '+ USPTO fees ($1,820)',
        featured: true,
        features: [
          'Everything in Consultation',
          'Complete patent drafting',
          'USPTO filing',
          'Office action responses (2 included)',
          'Prior art analysis',
          'Claims optimization',
          'Direct attorney access'
        ]
      },
      {
        name: 'Design Patent',
        description: 'Design protection',
        price: '$1,999',
        period: '+ USPTO fees ($860)',
        features: [
          'Design patent search',
          'Professional patent drawings',
          'Complete application',
          'USPTO filing',
          'Office action response (1 included)',
          'Expedited processing available',
          'Priority support'
        ]
      }
    ],
    faqs: [
      { question: 'What is patent infringement?', answer: 'Infringement occurs when someone makes, uses, sells, or imports a patented invention without permission during the patent term.' },
      { question: 'How do I know if someone is infringing?', answer: 'We conduct claim analysis comparing your patent claims to the accused product or process to determine infringement.' },
      { question: 'What can I do about infringement?', answer: 'Options include cease and desist letters, licensing negotiations, inter partes review, or patent infringement litigation.' },
      { question: 'What is a cease and desist letter?', answer: 'A formal demand to stop infringing activities, often the first step in enforcement and may lead to licensing or litigation.' },
      { question: 'How much does patent litigation cost?', answer: 'Patent litigation is expensive, typically $500,000-$5,000,000+ depending on case complexity, making early settlement attractive when possible.' },
      { question: 'What damages can I recover?', answer: 'Damages include lost profits, reasonable royalties, and potentially treble damages for willful infringement, plus attorney fees in exceptional cases.' },
      { question: 'What is patent licensing?', answer: 'Licensing grants others permission to use your patented invention in exchange for royalty payments, generating revenue without litigation.' },
      { question: 'Can I license my patent exclusively?', answer: 'Yes, you can grant exclusive licenses (limiting your own use), non-exclusive licenses (allowing multiple licensees), or sole licenses (exclusive except for yourself).' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
